"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsoleLogHandler = createConsoleLogHandler;
/* eslint-disable @typescript-eslint/no-explicit-any */
function createConsoleLogHandler(logLevel) {
    return {
        logLevel: logLevel,
        verbose: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.debug.apply(console, args);
        },
        breadcrumb: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.log.apply(console, args);
        },
        info: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.log.apply(console, args);
        },
        warn: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.warn.apply(console, args);
        },
        error: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return console.error.apply(console, args);
        },
    };
}
